/**
 * The five named Expressive brand colors (TRO-1515; palette TRO-1696), for imperative styles that
 * name a brand color rather than a token role. Everything else reads tokens through className or
 * `useThemeColors()`.
 *
 * Generated: edit `brand` in `design-system/tokens/tokens.json` and run `npm run tokens:apply`,
 * not this block.
 */
/* @tokens:start — GENERATED by `npm run tokens:apply` from design-system/tokens/tokens.json. */
export const expressiveBrand = {
  navy: "#202940",
  lime: "#c3ff4d",
  purple: "#7f9dff",
  paper: "#eef1fb",
  gray: "#4d5569",
} as const;
/* @tokens:end */
